import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withKeys as _withKeys, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2134edda"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "small-content setup-page x-center" }
const _hoisted_2 = { class: "y-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_create_header = _resolveComponent("create-header")!
  const _component_create_progress_bar = _resolveComponent("create-progress-bar")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_error_message = _resolveComponent("error-message")!
  const _component_ion_checkbox = _resolveComponent("ion-checkbox")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_create_header, {
        title: _ctx.lang.t('title'),
        hasBack: false
      }, null, 8, ["title"]),
      _createVNode(_component_create_progress_bar, { step: 0 }),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_ion_card, { class: "my-auto" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_card_header, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_card_title, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.lang.t("eventName")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_card_content, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_label, { position: "floating" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.lang.t("eventNameDesc")), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "start",
                            icon: _ctx.pencil
                          }, null, 8, ["icon"]),
                          _createVNode(_component_ion_input, {
                            modelValue: _ctx.CreateService.info.title,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.CreateService.info.title) = $event)),
                            id: "event_name",
                            autofocus: "true",
                            placeholder: _ctx.lang.t('enterName'),
                            onKeydown: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.submit()), ["enter"])),
                            onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.CreateService.saveState()))
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_error_message, {
                        value: _ctx.lang.t(_ctx.validator.message)
                      }, null, 8, ["value"]),
                      _hoisted_3,
                      _createVNode(_component_ion_label, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.lang.t("authMode")), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_item, {
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setAuth('simple'))),
                        class: "clickable"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_checkbox, {
                            slot: "start",
                            checked: _ctx.CreateService.info.auth === 'simple',
                            class: "no-events"
                          }, null, 8, ["checked"]),
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.lang.t("authSimple")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_item, {
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setAuth('full'))),
                        class: "clickable"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_checkbox, {
                            slot: "start",
                            checked: _ctx.CreateService.info.auth === 'full',
                            class: "no-events"
                          }, null, 8, ["checked"]),
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.lang.t("authFull")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _hoisted_4,
                      _createVNode(_component_ion_button, {
                        expand: "full",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.submit())),
                        disabled: !_ctx.validator.valid,
                        id: "continue_event_name"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.langGeneric.t("continue")) + " ", 1),
                          _createVNode(_component_ion_icon, { icon: _ctx.arrowForward }, null, 8, ["icon"])
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}